"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLocationAwarePurchaseMotionData = exports.fetchPurchaseMotionData = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _memoize = _interopRequireDefault(require("../utilities/memoize"));

var _q = _interopRequireDefault(require("q"));

var fetchPurchaseMotionData = (0, _memoize.default)(function (merchandiseIds) {
  return _apiClient.default.post('/monetization-service/v2/purchase-motions', {
    data: {
      merchandiseIds: merchandiseIds
    }
  });
});
exports.fetchPurchaseMotionData = fetchPurchaseMotionData;
var fetchLocationAwarePurchaseMotionData = (0, _memoize.default)(function (_ref) {
  var _ref$merchandiseIds = _ref.merchandiseIds,
      merchandiseIds = _ref$merchandiseIds === void 0 ? [] : _ref$merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter,
      _ref$fetchMetaData = _ref.fetchMetaData,
      fetchMetaData = _ref$fetchMetaData === void 0 ? true : _ref$fetchMetaData;
  var url = fetchMetaData ? '/monetization-service/v2/purchase-motions' : '/monetization-service/v2/purchase-motions/no-metadata';

  if (!apiGetter) {
    return _apiClient.default.get(url, {
      query: {
        merch: merchandiseIds,
        location: locations
      }
    });
  }

  return new _q.default.Promise(function (resolve, reject) {
    apiGetter.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest('purchase-motions');
    });
    apiGetter.onError(function () {
      window.quickFetch.removeEarlyRequest('purchase-motions');
      return _apiClient.default.get(url, {
        query: {
          merch: merchandiseIds,
          location: locations
        }
      }).then(resolve).catch(function (httpError) {
        reject(httpError);
      });
    });
  });
});
exports.fetchLocationAwarePurchaseMotionData = fetchLocationAwarePurchaseMotionData;